/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-avatar-corner-radius: Specifies the component's corner radius.
* @prop --calcite-avatar-color: Specifies the component's icon or initial color.
* @prop --calcite-avatar-background-color: Specifies the component's background color.
*
*/
:host {
  display: inline-block;
  overflow: hidden;
  border-radius: var(--calcite-avatar-corner-radius, 50%);
  color: var(--calcite-avatar-color, var(--calcite-color-text-2))
}

:host([scale=s]) {
  block-size: 1.5rem;
  inline-size: 1.5rem;
  font-size: var(--calcite-font-size--3)
}

:host([scale=m]) {
  block-size: 2rem;
  inline-size: 2rem;
  font-size: var(--calcite-font-size--2)
}

:host([scale=l]) {
  block-size: 2.75rem;
  inline-size: 2.75rem;
  font-size: var(--calcite-font-size-0)
}

.icon {
  display: flex
}

.background {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  align-items: center;
  justify-content: center;
  border-radius: var(--calcite-avatar-corner-radius, 50%)
}

.initials {
  font-weight: var(--calcite-font-weight-bold);
  text-transform: uppercase
}

.thumbnail {
  block-size: 100%;
  inline-size: 100%;
  border-radius: var(--calcite-avatar-corner-radius, 50%)
}

:host([hidden]) {
  display: none
}

[hidden] {
  display: none
}